import { ReactElement } from 'react';
import { SoundOutlined, TeamOutlined, ContactsOutlined, UploadOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import type { MenuProps } from 'antd';
import { SideBarBlock, SideBarLayout, MenuSection, StyledMenu, StyledDivider } from './index.style';
import Title from './Title';
import Footer from './Footer';

const SideBar = (): ReactElement => {
  const navigate = useNavigate();

  const menuItems: MenuProps['items'] = [
    {
      key: 'recordings',
      icon: <SoundOutlined />,
      label: '録音一覧',
      onClick: () => void navigate('/recordings'),
    },
    {
      key: 'advisors',
      icon: <TeamOutlined />,
      label: '営業担当者管理',
      onClick: () => void navigate('/advisors'),
    },
    {
      key: 'customers',
      icon: <ContactsOutlined />,
      label: '顧客管理',
      onClick: () => void navigate('/customers'),
    },
    {
      key: 'upload',
      icon: <UploadOutlined />,
      label: '録音アップロード',
      onClick: () => void navigate('/upload-recording'),
    },
  ];

  return (
    <SideBarBlock>
      <SideBarLayout>
        <Title />
        <StyledDivider />
        <MenuSection>
          <StyledMenu mode='inline' items={menuItems} />
        </MenuSection>
        <StyledDivider />
        <Footer />
      </SideBarLayout>
    </SideBarBlock>
  );
};

export default SideBar;
